module.exports = __webpack_public_path__ + "static/media/vitraz2.cbe70427.jpg";